import React from 'react';
import PostMargins from '../postmargins';

const is404selector = ({is}) => is['404'];

export const DefaultPost = ({post, excerpted, showSharing}) => {
    const {RawHTML} = polyphony.components.generic;
    const {PostWrapper, PostBody, SharingButtons} = polyphony.components.frontend;
    const is404 = polyphony.useState(is404selector);

    return (
        <PostWrapper post={post} style={{display: 'flex', flexFlow: 'column nowrap', alignItems: 'center'}}>
            <PostMargins style={{display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center',  width: '100%'}}>
                {excerpted && <a href={post.permalink}><RawHTML tag='h1' className="post-title">{post.title}</RawHTML></a>}
                {excerpted && <h4>{post.post_date}</h4>}
                {excerpted && <RawHTML>{post.excerpt}</RawHTML>}
                {!excerpted && <>
                    {post.content.map((x, i) => <PostBody key={i}>{x}</PostBody>)}
                    {!is404 && showSharing && <SharingButtons twitter facebook linkedin email url={post.permalink} />}
                </>}
            </PostMargins>
        </PostWrapper>
    );
};

DefaultPost.defaultProps = {
    showSharing: false
};

export default DefaultPost;

